import { completeLoadingState } from '@/entities/userInterface/slices/loaderSlice'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const setupAdmin = createAsyncThunk('admin/setup', async (_, { dispatch }) => {
  dispatch(completeLoadingState())
})